import { render, staticRenderFns } from "./send-modal.vue?vue&type=template&id=3e28847b"
import script from "./send-modal.vue?vue&type=script&lang=js"
export * from "./send-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports